"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptionsBySatellites = void 0;
var getOptionsBySatellites = function (satellites) {
    return satellites.map(function (_a) {
        var name = _a.name, domain = _a.domain, provider_id = _a.provider_id;
        return ({
            label: name,
            value: domain,
            provider_id: provider_id,
        });
    });
};
exports.getOptionsBySatellites = getOptionsBySatellites;
